import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Signal, inject } from '@angular/core';
import { ClaimKey } from '../../../models/api/core/claim-key';
import { Snackbar } from '../../../services/snackbar/snackbar.service';
import { WatchlistService } from '../../../services/view/watchlist.service';

@Component({
  selector: 'app-watch-button',
  imports: [CommonModule],
  template: `
    <button
      type="button"
      class="tw-border-0 tw-bg-transparent tw-p-0 tw-cursor-pointer"
      aria-label="Watchlist"
      [attr.aria-pressed]="watching()"
      (click)="toggle($event)"
    >
      @if (watching()) {
        <span class="tw-pl-0 md:tw-pl-1 tw-mb-0.5 fa-layers fa-fw">
          <i
            class="tw-pl-0 md:tw-pl-1 tw-mb-0.5 fa-solid fa-star"
            style="color: var(--sed-purple-80-color);"
          ></i>
          <i
            class="tw-pl-0 md:tw-pl-1 tw-mb-0.5 fa-light fa-star"
            style="color: black;"
          ></i>
        </span>
      }
      @if (!watching()) {
        <span
          ><i class="tw-pl-0 md:tw-pl-1 tw-mb-0.5 fa-star fa-light"></i
        ></span>
      }
    </button>
  `,
  styles: [],
})
export class WatchButtonComponent implements OnInit {
  private watchlist = inject(WatchlistService);
  private snackbar = inject(Snackbar);

  @Input()
  recordSource: string;

  @Input()
  recordId: string;

  watching!: Signal<boolean>;

  ngOnInit() {
    this.watching = this.watchlist.isWatching(this.recordSource, this.recordId);
  }

  async toggle(event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    try {
      const claimKey: ClaimKey = {
        recordId: this.recordId,
        recordSource: this.recordSource,
      };
      if (this.watching()) {
        await this.watchlist.remove([claimKey]);
        this.snackbar.show('Claim removed from watchlist', 'Success');
      } else {
        await this.watchlist.add(claimKey);
        this.snackbar.show('Claim added to watchlist', 'Success');
      }
    } catch (err) {
      this.snackbar.show('Failed to update watchlist', 'Error');
      console.error(err);
    }
  }
}
